import Vue from 'vue';
import 'dotenv/config';
// axios
import axios from 'axios';
import Swal from 'sweetalert2';
import { getHostTenant, tenantLoginPath } from '@/services/tenantHost';

let baseURL = process.env.VUE_APP_HOST_API_BACKEND_PROD;
if (process.env.VUE_APP_MODE_APP !== 'production' && process.env.VUE_APP_HOST_API_BACKEND_DEV) {
  baseURL = process.env.VUE_APP_HOST_API_BACKEND_DEV;
}

const axiosIns = axios.create({
  baseURL,
});

axiosIns.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Envia slug do tenant atual para o backend identificar o banco correto.
  // Durante impersonação do AdminDKP: mantém auth no DKP, mas sinaliza o banco alvo.
  const impersonateSlug = localStorage.getItem('dkpImpersonateSlug');

  const hostTenant = getHostTenant();
  if (hostTenant) {
    config.baseURL = '/api';
    config.headers['x-tenant-slug'] = hostTenant.slug;
    delete config.headers['x-admin-view-tenant'];
  } else if (impersonateSlug && impersonateSlug !== 'dkp') {
    // Impersonando outro tenant: auth via DKP, mas dados do tenant alvo
    localStorage.setItem('tenantSlug', 'dkp');
    config.headers['x-tenant-slug'] = 'dkp';
    config.headers['x-admin-view-tenant'] = impersonateSlug;
  } else {
    // Se o usuário é master (AdminDKP), garante que sempre usa o banco DKP
    // independente do tenantSlug que possa ter ficado de uma sessão anterior
    let userData = {};
    try { userData = JSON.parse(localStorage.getItem('userData') || '{}'); } catch (_) {}
    const isUserMaster = Number(userData.usuario_master) === 1;

    const tenantSlug = isUserMaster
      ? 'dkp'
      : (localStorage.getItem('tenantSlug') || process.env.VUE_APP_TENANT_SLUG || 'dkp');

    config.headers['x-tenant-slug'] = tenantSlug;
  }

  // Perfil ATIVO escolhido no login (perfilLogado). O backend usa este id para
  // escopar permissões/visibilidade ao perfil selecionado — e não à união de
  // todos os perfis do usuário (ex.: alguém com Representante + AdminDKP logado
  // como Representante deve ser escopado como representante).
  try {
    const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado') || '{}');
    if (perfilLogado && perfilLogado.id_perfil_acesso != null) {
      config.headers['x-perfil-id'] = String(perfilLogado.id_perfil_acesso);
    }
  } catch (_) {}

  return config;
});

// Evita Swal/redirect duplicados quando vários requests retornam 401 em paralelo
let isHandling401 = false;

axiosIns.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401 && !isHandling401) {
      isHandling401 = true;

      await Swal.fire({
        icon: 'warning',
        title: 'Sessão expirada',
        text: 'Seu token de acesso expirou. Por favor, faça login novamente.',
        confirmButtonText: 'Ok',
      });

      // O botão "Ok" faz o MESMO logout do dropdown do usuário (auth/LOGOUT_USER:
      // limpa sessão, carrinho, rascunhos, cores do tenant e estado Vuex) e
      // redireciona para a tela de login do tenant atual. tenantSlug é capturado
      // antes para preservar o tenant na URL; o redirect via window.location.assign
      // recarrega a página, resetando ability/estado por completo.
      const slug = (localStorage.getItem('tenantSlug') || '').toLowerCase().trim();
      try {
        const store = (await import('@/store')).default;
        await store.dispatch('auth/LOGOUT_USER');
      } catch (_) {
        // Fallback defensivo caso o store não esteja disponível
        localStorage.removeItem('userData');
        localStorage.removeItem('userPermissions');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('dkpImpersonateSlug');
      }
      // Chaves extras limpas pelo logout do dropdown (não cobertas por LOGOUT_USER)
      localStorage.removeItem('perfilLogado');
      localStorage.removeItem('lgn_admin');
      localStorage.removeItem('lgn_admin_metadata');
      window.location.assign(tenantLoginPath(slug));
    }

    return Promise.reject(error);
  },
);

// async handlerCancelarPedido() {
//   Swal.fire({
//     title: 'Cancelar Pedido',
//     text: 'Deseja realmente cancelar o pedido?',
//     icon: 'warning',
//     showCancelButton: true,
//     confirmButtonText: 'Sim',
//     cancelButtonText: 'Não',
//     confirmButtonColor: '#d33',
//     cancelButtonColor: '#3085d6',
//   }).then((result) => {
//     if (result.isConfirmed) {
//       this.$store.dispatch('PedidosStore/clearPedidoAndItemPedido')
//       this.$router.push({ name: 'home' })
//     }
//   })
// }

// axiosIns.interceptors.response.use(
//     response => response,
//     error => {
//         if (error.response.status === 401) {
//             localStorage.removeItem('userData')
//             localStorage.removeItem('accessToken')
//             localStorage.removeItem('refreshToken')
//             // window.location.href = '/login'
//         }
//         return Promise.reject(error)
//     }
// )

Vue.prototype.$http = axiosIns;

export default axiosIns;
